import { logToKibana } from './log-to-kibana';

export const iwaAddEvent = (...variables: (string | (() => string))[]): void => {
    if (window.requestIdleCallback) {
        window.requestIdleCallback(() => iwa(...variables));
    } else {
        iwa(...variables);
    }
};

const iwa = (...variables: any): void => {
    const { Ad } = window.Inpl;
    Ad.event?.onReady(() => {
        if (window.iwa3) {
            window.iwa3(
                variables.map((item: any) => {
                    if (typeof item === 'string') return item;
                    if (typeof item === 'function') return item();
                })
            );
        } else {
            console.error('IWA is unavailable.');
            logToKibana({
                message: 'IWA is unavailable.',
            });
        }
    });
};
